module.exports = __webpack_public_path__ + "img/unifisa-logo-menu.c71db09a.png";